var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as styles from './password-strength-meter.style';
var passwordStrengthDisplay = [
    { index: 0 },
    { index: 1 },
    { index: 2 },
    { index: 4 },
];
export var PasswordStrengthMeter = function (_a) {
    var type = _a.type, message = _a.message;
    return (_jsxs("div", __assign({ className: 'my-1 mt-2' }, { children: [_jsx("div", __assign({ className: "flex flex-row justify-evenly" }, { children: passwordStrengthDisplay.map(function (display, index) { return (_jsx("div", { className: styles.getStrengthBarStyle(type, display.index) }, 'password-strength-meter-index-' + index)); }) })), message && (_jsx("div", __assign({ className: styles.message + styles.getStrengthBarMessageStyle(type) }, { children: message })))] })));
};
export default PasswordStrengthMeter;
//# sourceMappingURL=password-strength-meter.js.map